import React from "react";
import TargetUserModal from "./TargetUserModal";
import { useOrderContext } from "../../OrderContext";

export default function TargetGeneralInfo() {
    const { order } = useOrderContext();
    const [showModal, setShowModal] = React.useState(false);

    return (
        <div className="col p-6 cursor-default">
            <div className="fw-bolder text-decoration-underline mb-2">На кого оформлен заказ</div>
            <div>
                <span className="fw-bolder">ФИО: </span>
                <a href={`/admin/distributors/${order.target.id}`} target="_blank">
                    {order.target.full_name}
                </a>
            </div>
            <div>
                <span className="fw-bolder">Почта: </span>
                {order.target.email}
            </div>
            <div>
                <span className="fw-bolder">Личный номер: </span>
                {order.target.personal_number}
            </div>
            <div>
                <span className="fw-bolder">Статус по маркетинг-плану:{` `}</span>
                {order.target.marketing_plan_status}
            </div>
            {order.is_editable && (
                <div>
                    <a
                        className="d-block link link-primary w-max-content"
                        href="#"
                        onClick={(event: React.MouseEvent<HTMLAnchorElement>): void => {
                            event.preventDefault();
                            setShowModal(true);
                        }}
                    >
                        Редактировать
                    </a>
                </div>
            )}
            {order.is_editable && showModal && <TargetUserModal closeModal={(): void => setShowModal(false)} />}

        </div>
    );
}
